import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Globe, Phone, Mail, MapPin, Loader2, ArrowRight } from 'lucide-react';
import './BusinessSetup.css';
import axios from 'axios';

const INDUSTRIES = [
  'Gym','Salon','Med Spa','Dental','Fitness Studio','Restaurant','Retail','Professional Services','Real Estate','Healthcare','Other','Technology'
];

const BusinessSetup = ({ userId, onComplete }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [user,setUser] = useState('');
  const [demoKey, setDemoKey] = useState("");
  //console.log("userssss");
  //console.log(userId);
  //const [user,setUser]= useState(userId);
  const [formData, setFormData] = useState({
    owner_id : userId || "",
    name: '',
    industry: '',
    description: '',
    website_url: '',
    phone: '',
    email: '',
    address: '',
    product: '',
    service: '',
  });
  const sessionId = localStorage.getItem('session_id');

  useEffect(() => {
    const fetchUser = async () => {
        try {
            const sessionId = localStorage.getItem('session_id');
            //console.log("SESSION ID:", sessionId)  // ← print 1
            
            if (!sessionId) return;
            
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user`, {
                params: { sessionId },
            });
            //console.log("USER RESPONSE:", res.data)      // ← print 2
            //console.log("USER ID:", res.data.userId)   

            setUser(res.data);
            setFormData(prev => ({ ...prev, owner_id: res.data.userId }))  // ← userId not id
            //console.log(user);
        } catch (error) {
            console.error(error.message)
        }
    }

    fetchUser()
}, [])

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.industry) return;

    setLoading(true);
    
    const result = await axios.post(
  `${process.env.REACT_APP_BACKEND_URL}/leadslist`,
  formData,
  {
    headers: {
      'x-api-key': demoKey
    }
  }
);
    setLoading(false);
    console.log(userId);
    if (result?.data?.success) {
    navigate('/dashboard');
  }

    //if (result) //onComplete();
    //{
      //navigate('/dashboards2');
    //}
  };

  return (
    <div className="business-setup-wrapper">
      <div className="business-card">
        {/* Header */}
        <div className="business-card-header">
          <div className="logo"><Building2 color="white" size={28} /></div>
          <h1>Set Up Your Business</h1>
          <p>Tell us about your business so we can create personalized marketing content</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
  <label
    style={{
      fontSize: '14px',
      fontWeight: '500'
    }}
  >
    Demo Key
  </label>

  <input
    type="text"
    value={demoKey}
    onChange={(e) => setDemoKey(e.target.value)}
    style={{
      width: '100%',
      padding: '10px 16px',
      borderRadius: '8px',
      border: '1px solid #e5e7eb',
      fontSize: '14px',
      background: '#ffffff',
      outline: 'none',
      transition: 'border-color 0.2s'
    }}
    placeholder="Enter your demo key"
  />
</div>
        </div>

        {/* Form */}
        <div className="business-card-content">
          <form className="business-form" onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group relative-input">
                <label>Business Name *</label>
                <Building2 className="input-icon" />
                <input
                  type="text"
                  placeholder="Your Business Name"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label>Industry *</label>
                <select
                  value={formData.industry}
                  onChange={(e) => setFormData({...formData, industry: e.target.value})}
                  required
                >
                  <option value="">Select industry</option>
                  {INDUSTRIES.map(ind => (
                    <option key={ind} value={ind}>{ind}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>Description</label>
              <textarea
                placeholder="Tell us about your business..."
                value={formData.description}
                onChange={(e) => setFormData({...formData, description: e.target.value})}
              />
            </div>

            <div className="form-grid">
              <div className="form-group relative-input">
                <label>Website</label>
                <Globe className="input-icon" />
                <input
                  type="url"
                  placeholder="https://yourbusiness.com"
                  value={formData.website_url}
                  onChange={(e) => setFormData({...formData, website_url: e.target.value})}
                />
              </div>

              <div className="form-group relative-input">
                <label>Phone</label>
                <Phone className="input-icon" />
                <input
                  type="tel"
                  placeholder="(555) 000-0000"
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                />
              </div>
            </div>

            <div className="form-grid">
              <div className="form-group relative-input">
                <label>Email</label>
                <Mail className="input-icon" />
                <input
                  type="email"
                  placeholder="contact@yourbusiness.com"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                />
              </div>

              <div className="form-group relative-input">
                <label>Address</label>
                <MapPin className="input-icon" />
                <input
                  type="text"
                  placeholder="123 Main St, City"
                  value={formData.address}
                  onChange={(e) => setFormData({...formData, address: e.target.value})}
                />
              </div>

              <div className="form-group relative-input">
                <label>Product</label>
                <MapPin className="input-icon" />
                <input
                  type="text"
                  placeholder="123 Main St, City"
                  value={formData.product}
                  onChange={(e) => setFormData({...formData, product: e.target.value})}
                />
              </div>

              
              <div className="form-group relative-input">
                <label>Service</label>
                <MapPin className="input-icon" />
                <input
                  type="text"
                  placeholder="123 Main St, City"
                  value={formData.service}
                  onChange={(e) => setFormData({...formData, service: e.target.value})}
                />
              </div>
            </div>

            <button
              type="submit"
              className="button"
              disabled={loading || !formData.name || !formData.industry}
            >
              {loading ? <Loader2 className="loader" /> : <>Get Started <ArrowRight /></>}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BusinessSetup;
